import { createRoot } from "react-dom/client";
import Index from "./Index.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<Index />);
